import React from 'react'

class MembershipFooter extends React.Component {
  footer() {
    switch (this.props.membershipType) {
      case 'monthly':
        return this.monthly()
      case 'yearly':
        return this.yearly()
      case 'contract':
        return this.contract()
    }
  }

  monthly() {
    return (
      <ul className="inline-list text-copy-1 lh18">
        <li>
          You're currently on a ${this.props.paymentAmount}/month membership {this.props.exclusiveLeadDetails ? `and $${this.props.exclusiveLeadDetails['top_up_credit']} Credit (incl. GST) to quote on Limited Competition Leads ` : '(incl. GST)'}.
        </li>
        {
          this.props.exclusiveLeadDetails ?
            <li>Your payment of ${this.props.exclusiveLeadDetails['amount']}/month for ${this.props.exclusiveLeadDetails['top_up_credit']} credit will not be affected by any changes you make to your membership.</li>
          :
          ''
        }
        { this.props.hasNextBilling &&
          <li>
            {`Your next billing date is on ${this.props.initialBillingDate} for your membership from ${this.props.initialBillingDate} to ${this.props.membershipCycleEndDate}.`}
          </li>
        }
        <li>
          You can make changes to your coverage, suburb or tasks above and click Update to calculate your new price.
        </li>
        {
          this.props.exclusiveLeadOnlyContract &&
          <li>Please call {this.props.supportPhoneNumber} to upgrade to a 12 month plan.</li>
        }
      </ul>
    )
  }

  yearly() {
    return(
      <ul className="inline-list text-copy-1 lh18">
        <li>
          You're currently on a ${this.props.paymentAmount} membership (incl. GST) paid up front until {this.props.initialBillingDate}.
        </li>
        <li>
          You can make changes to your coverage, suburb or tasks above and click Update to calculate your new price.
        </li>
      </ul>
    )
  }

  contract() {
    return(
      <ul className="inline-list text-copy-1 lh18">
        <li>
          You're currently on a ${parseFloat(this.props.paymentAmount).toFixed(2)}/month membership {this.props.totalExclusiveLeadCredits !== 0 ? `and $${parseFloat(this.props.totalExclusiveLeadCredits).toFixed(2)} of credit (incl. GST) as applied by the schedule to quote on Limited Competition Leads` : '(incl. GST)'} for a set plan period.
        </li>
        {
          this.props.totalExclusiveLeadCredits !== 0 ?
            <li>Your payment for credit will not be affected by any changes you make to your membership.</li>
          :
          ''
        }
        <li>
          {`Your next billing date is on ${this.props.initialBillingDate} and your plan ends on ${this.props.membershipEndDate}.`}
        </li>
      </ul>
    )
  }

  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <div className="card card-flat card-pad-md mt24 mb24">
              <div className="font-21 text-copy-2 bold pb16">
                Your membership & billing details
              </div>
              { this.footer() }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MembershipFooter
